import { createSlice } from '@reduxjs/toolkit'

export const PlansStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    plans: [],
    status: PlansStatus.LOADING,
    errorMessage: null,
}

const plansSlice = createSlice({
    name: 'plans',
    initialState,
    reducers: {
        getPlansRequest: state => {
            state.plans = []
            state.status = PlansStatus.LOADING
        },
        getPlansRequestSuccess: (state, action) => {
            state.plans = action.payload.plans
            state.status = PlansStatus.SUCCESS
        },
        getPlansRequestFailure: (state, action) => {
            state.errorMessage = action.payload.error
            state.status = PlansStatus.FAILURE
        },
    },
})

const {
    getPlansRequest,
    getPlansRequestSuccess,
    getPlansRequestFailure,
} = plansSlice.actions

export const plansActions = {
    getPlansRequest,
    getPlansRequestSuccess,
    getPlansRequestFailure,
}

export const plansSelectors = {
    getPlansState: state => state.plans.plans,
    getIsFetchingState: state => state.plans.status === PlansStatus.LOADING,
    getHasErrorState: state => state.plans.status === PlansStatus.FAILURE,
    getErrorState: state => state.plans.errorMessage,
}

export default plansSlice.reducer
